// A copy of the default first responder messages as-of December 13, 2019, jslib 1.16.0
import { firstResponderMessagesEN } from './lib/intl/en-US';

// Travis's preview account, first responder program
export const programId = '5ef636539651af1a9756b887';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': firstResponderMessagesEN,
    },
};
